module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "warp_contrainer"
  }, [_c('div', {
    staticClass: "search_container"
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "待入库",
      "name": "3"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "已入库",
      "name": "7"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "已出库",
      "name": "8"
    }
  })], 1), _vm._v(" "), _c('div', [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "合箱编码",
      "clearable": ""
    },
    on: {
      "clear": function($event) {
        return _vm.init()
      }
    },
    model: {
      value: (_vm.search.boxNumber),
      callback: function($$v) {
        _vm.$set(_vm.search, "boxNumber", $$v)
      },
      expression: "search.boxNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "用户VIP号",
      "clearable": ""
    },
    on: {
      "clear": function($event) {
        return _vm.init()
      }
    },
    model: {
      value: (_vm.search.vipCode),
      callback: function($$v) {
        _vm.$set(_vm.search, "vipCode", $$v)
      },
      expression: "search.vipCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "255px",
      "padding-right": "6px"
    },
    attrs: {
      "remote": "",
      "remote-method": _vm.remoteMethod,
      "reserve-keyword": "",
      "filterable": "",
      "loading": _vm.loading,
      "clearable": "",
      "placeholder": "批次"
    },
    on: {
      "change": _vm.batchChange,
      "clear": _vm.clearChecked
    },
    model: {
      value: (_vm.search.batchNum),
      callback: function($$v) {
        _vm.$set(_vm.search, "batchNum", $$v)
      },
      expression: "search.batchNum"
    }
  }, _vm._l((_vm.batchList), function(item) {
    return _c('el-option', {
      key: item.sendId,
      attrs: {
        "label": item.remark,
        "value": item.remark
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "派送点"
    },
    on: {
      "change": function($event) {
        return _vm.init()
      },
      "clear": function($event) {
        return _vm.init()
      }
    },
    model: {
      value: (_vm.search.deliveryTitle),
      callback: function($$v) {
        _vm.$set(_vm.search, "deliveryTitle", $$v)
      },
      expression: "search.deliveryTitle"
    }
  }, _vm._l((_vm.deliveryAddressList), function(item) {
    return _c('el-option', {
      key: item.addressId,
      attrs: {
        "label": item.deliveryTitle,
        "value": item.deliveryTitle
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "货物类型"
    },
    on: {
      "change": function($event) {
        return _vm.init()
      },
      "clear": function($event) {
        return _vm.init()
      }
    },
    model: {
      value: (_vm.search.goodType),
      callback: function($$v) {
        _vm.$set(_vm.search, "goodType", $$v)
      },
      expression: "search.goodType"
    }
  }, _vm._l((_vm.goodTypeSelect), function(item) {
    return _c('el-option', {
      key: item.goodType,
      attrs: {
        "label": item.goodName,
        "value": item.goodType
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.init()
      }
    }
  }, [_vm._v("查询")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    ref: "table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.dataList,
      "border": "",
      "stripe": "",
      "row-key": "boxId",
      "max-height": "550px"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "35",
      "align": "center",
      "selectable": _vm.selectable,
      "reserve-selection": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "boxNumber",
      "label": "合箱编码",
      "align": "center",
      "width": "180px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "货物类型",
      "align": "center",
      "width": "120px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.goodType == 1) ? _c('span', {
          staticClass: "tag"
        }, [_vm._v(" 海运 ")]) : (scope.row.goodType == 2) ? _c('span', {
          staticClass: "tag tag1"
        }, [_vm._v("\n            海运大件\n          ")]) : (scope.row.goodType == 3) ? _c('span', {
          staticClass: "tag tag3"
        }, [_vm._v("\n            空运\n          ")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "订单数量",
      "align": "center",
      "width": "120px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.orderCount) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "用户VIP号",
      "align": "center",
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(scope.row.vipCodes) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "批次",
      "prop": "sendRemark",
      "min-width": "180px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "箱号",
      "prop": "boxNumber",
      "min-width": "180px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "派送点",
      "align": "left",
      "width": "260px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('h4', [_vm._v(_vm._s(scope.row.deliveryTitle))]), _vm._v("\n          " + _vm._s(scope.row.address) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "align": "center",
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm.strStatus(scope.row.status)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 3) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.outHanlder(scope.row)
            }
          }
        }, [_vm._v("签收入库")]) : _vm._e(), _vm._v(" "), (scope.row.status == 7) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.outBoxHanlder(scope.row)
            }
          }
        }, [_vm._v("出库")]) : _vm._e(), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.viewHandler(scope.row)
            }
          }
        }, [_vm._v("查看详情")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [(_vm.activeName == '7' && _vm.accountObj.roleId == 1) ? _c('div', {
    staticClass: "footer_left"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.outBoxHanlder(null)
      }
    }
  }, [_vm._v("批量出库")])], 1) : _vm._e(), _vm._v(" "), (_vm.activeName == '3') ? _c('div', {
    staticClass: "footer_left"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.intoBoxHanlder(null)
      }
    }
  }, [_vm._v("批量入库")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "footer_pagination"
  }, [_c('el-pagination', {
    attrs: {
      "page-sizes": _vm.paginations.page_sizes,
      "page-size": _vm.paginations.page_size,
      "layout": _vm.paginations.layout,
      "total": _vm.paginations.total,
      "current-page": _vm.paginations.page_index
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1)])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.viewDialog.show,
      "title": _vm.viewDialog.title,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "900px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.viewDialog, "show", $event)
      }
    }
  }, [_c('div', {
    staticClass: "order_main"
  }, [_c('div', {
    staticClass: "order_base"
  }, [_c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("合箱编号：")]), _c('span', {
    staticClass: "l_value"
  }, [_vm._v(_vm._s(_vm.viewDialog.boxInfo ? _vm.viewDialog.boxInfo.boxNumber : ""))]), _vm._v(" "), _c('span', {
    staticClass: "l_label"
  }, [_vm._v("派送点：")]), _c('span', {
    staticClass: "l_value"
  }, [_vm._v(_vm._s(_vm.viewDialog.boxInfo ? _vm.viewDialog.boxInfo.deliveryTitle : ""))]), _vm._v(" "), _c('span', {
    staticClass: "l_label"
  }, [_vm._v("合箱时间：")]), _c('span', {
    staticClass: "l_value"
  }, [_vm._v(_vm._s(_vm.viewDialog.boxInfo ?
    _vm.toDate(_vm.viewDialog.boxInfo.createTime, "yyyy-MM-dd hh:mm:ss") :
    ""))])]), _vm._v(" "), _c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("订单状态：")]), _c('span', {
    staticClass: "l_value"
  }, [_vm._v("待入库")]), _vm._v(" "), _c('span', {
    staticClass: "l_label"
  }, [_vm._v("订单数量：")]), _c('span', {
    staticClass: "l_value"
  }, [_vm._v(_vm._s(_vm.viewDialog.boxInfo ? _vm.viewDialog.boxInfo.orderCount : ""))]), _vm._v(" "), _c('span', {
    staticClass: "l_label"
  }, [_vm._v("预估费用：")]), _c('span', {
    staticClass: "l_value"
  }, [_vm._v("CAD\n            " + _vm._s(_vm.viewDialog.boxInfo ? _vm.viewDialog.boxInfo.totalFreight : ""))])]), _vm._v(" "), _c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "600"
    }
  }, [_vm._v("用户VIP号：")]), _c('span', [_vm._v(_vm._s(_vm.viewDialog.boxInfo ? _vm.viewDialog.boxInfo.vipCodes : ""))])]), _vm._v(" "), _c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("货柜号：")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "输入货柜号"
    },
    model: {
      value: (_vm.viewDialog.boxContainerNumber),
      callback: function($$v) {
        _vm.$set(_vm.viewDialog, "boxContainerNumber", $$v)
      },
      expression: "viewDialog.boxContainerNumber"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "l_tip"
  }, [_vm._v("（中转站签收可不填）")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "order_detail"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bolder",
      "font-size": "16px"
    }
  }, [_vm._v("订单清单")])]), _vm._v(" "), _c('div', {
    staticClass: "product_list"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.viewDialog.list,
      "border": "",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "名称",
      "min-width": "200px",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(scope.row.productName) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "客户",
      "prop": "realName",
      "min-width": "70px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(scope.row.realName) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "vip号",
      "prop": "vipCode",
      "min-width": "60px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(scope.row.vipCode) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "物流公司",
      "prop": "expressCompany",
      "min-width": "80px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "运单号",
      "prop": "expressNo",
      "min-width": "125px",
      "align": "left"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "slot": "reference",
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    },
    slot: "reference"
  }, [_vm._v("提 交")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.viewDialog.show = false
      }
    }
  }, [_vm._v("关 闭")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.detailDialog.show,
      "title": _vm.detailDialog.title,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "1100px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.detailDialog, "show", $event)
      }
    }
  }, [_c('div', {
    staticClass: "order_main"
  }, [_c('div', {
    staticClass: "order_base"
  }, [_c('div', {
    staticClass: "l_item"
  }, [_c('span', {
    staticClass: "l_label"
  }, [_vm._v("合箱编号：")]), _c('span', {
    staticClass: "l_value"
  }, [_vm._v(_vm._s(_vm.detailDialog.boxInfo ? _vm.detailDialog.boxInfo.boxNumber : ""))]), _vm._v(" "), _c('span', {
    staticClass: "l_label"
  }, [_vm._v("订单数量：")]), _c('span', {
    staticClass: "l_value"
  }, [_vm._v(_vm._s(_vm.detailDialog.boxInfo ? _vm.detailDialog.boxInfo.deliveryTitle : ""))]), _vm._v(" "), _c('span', {
    staticClass: "l_label"
  }, [_vm._v("货物类型：")]), _c('span', {
    staticClass: "l_value"
  }, [_vm._v(_vm._s(_vm.detailDialog.boxInfo ?
    _vm.stringGoodType(_vm.detailDialog.boxInfo.goodType) :
    ""))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-weight": "600"
    }
  }, [_vm._v("用户VIP号：")]), _c('span', [_vm._v(_vm._s(_vm.detailDialog.boxInfo ? _vm.detailDialog.boxInfo.vipCodes : ""))])])]), _vm._v(" "), _c('div', {
    staticClass: "order_detail"
  }, [_c('div', {
    staticClass: "product_list"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.detailDialog.list,
      "border": "",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "align": "center",
      "label": "#"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "名称",
      "width": "180px",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(scope.row.productName) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "货物类型",
      "prop": "goodType",
      "min-width": "90px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(_vm.stringGoodType(scope.row.goodType)) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "客户",
      "prop": "realName",
      "min-width": "70px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(scope.row.realName) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "vip号",
      "prop": "vipCode",
      "min-width": "80px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(scope.row.vipCode) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "物流公司",
      "prop": "expressCompany",
      "min-width": "80px",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "运单号",
      "prop": "expressNo",
      "min-width": "100px",
      "align": "left"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品价值",
      "prop": "predictTotal",
      "width": "80px",
      "align": "left"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "prop": "status",
      "width": "70px",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 1) ? _c('span', {
          staticClass: "status1"
        }, [_vm._v("待入库")]) : (scope.row.status == 2) ? _c('span', {
          staticClass: "status2"
        }, [_vm._v("（国内）已入库")]) : (scope.row.status == 3) ? _c('span', {
          staticClass: "status3"
        }, [_vm._v("（国内）已出库")]) : (scope.row.status == 4) ? _c('span', {
          staticClass: "status4"
        }, [_vm._v("已结单")]) : (scope.row.status == -1) ? _c('span', {
          staticClass: "status-1"
        }, [_vm._v("已取消")]) : (scope.row.status == 7) ? _c('span', {
          staticClass: "status7"
        }, [_vm._v("(中心仓)已入库")]) : (scope.row.status == 8) ? _c('span', {
          staticClass: "status8"
        }, [_vm._v("(中心仓)已出库")]) : (scope.row.status == 9) ? _c('span', {
          staticClass: "status9"
        }, [_vm._v("(派送)已入库")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "运费(CAD)",
      "prop": "total",
      "width": "95px",
      "align": "left"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "下单时间",
      "prop": "addTime",
      "width": "100px",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(_vm.toDate(scope.row.addTime, "yyyy-MM-dd hh:mm:ss")) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "派送点",
      "prop": "deliveryTitle",
      "width": "100px",
      "align": "left"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.detailDialog.show = false
      }
    }
  }, [_vm._v("确 定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.outDialog.show,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "500px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.outDialog, "show", $event)
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.outDialog.content))])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.outDialog.boxId) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.outSubmit()
      }
    }
  }, [_vm._v("确 定")]) : _vm._e(), _vm._v(" "), (!_vm.outDialog.boxId) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.batchOutSubmit()
      }
    }
  }, [_vm._v("确 定")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "default"
    },
    on: {
      "click": function($event) {
        _vm.outDialog.show = false
      }
    }
  }, [_vm._v("取 消")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.intoDialog.show,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "modal-append-to-body": false,
      "width": "500px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.intoDialog, "show", $event)
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.intoDialog.content))])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.batchIntoSubmit()
      }
    }
  }, [_vm._v("确 定")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "default"
    },
    on: {
      "click": function($event) {
        _vm.intoDialog.show = false
      }
    }
  }, [_vm._v("取 消")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c05e39a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/distribution/order.vue
// module id = 1255
// module chunks = 2